import { getColorTones } from '@agria/theme/src/utils';
import { brandColors } from './brand';

export const systemColors = {
  systemFocus: `0px 0px 0px 2px #FFF, 0px 0px 0px 4px ${brandColors.brandTwo}`,
  systemFocusValid: `0px 0px 0px 1px #4E9C33, 0px 0px 0px 3px #FFF, 0px 0px 0px 5px ${brandColors.brandTwo};`,
  systemFocusInvalid: `0px 0px 0px 1px #C92C36, 0px 0px 0px 3px #FFF, 0px 0px 0px 5px ${brandColors.brandTwo};`,
  systemInformation: '#276AE6',
  systemWarning: '#E66D00',
  systemSuccess: '#3CB789',
  systemSuccessLight: '#F6F9F5',
  systemError: '#DB0F30',
  ...getColorTones('#DB0F30', 'systemError'),
  systemInformation100: '#276AE6',
  systemSuccess100: '#3CB789',
  systemError100: '#DB0F30',
  systemInformation10: '#F8F8FF',
  systemSuccess10: '#F6F9F5',
  systemError10: '#FFF6F5',
  systemCaution: '#E66D00',
  systemCautionLight: '#FFF7E8',
} as const;
